import React, { FC } from 'react'

// Utils
import { noop } from '@sketch/utils'

// Components
import { Button } from '@sketch/components'

// Styles
import {
  Text,
  SketchLogoBlack,
  SketchLogoText,
  Modal,
} from './SubscriptionDoneModal.styles'

// Types
import { ModalInjectedProps } from 'containers/ModalManager'

interface SubscriptionDoneModalProps extends ModalInjectedProps {
  onHide: () => void
}

const SubscriptionDoneModal: FC<SubscriptionDoneModalProps> = ({ onHide }) => {
  const handleClick = () => {
    onHide()
  }
  return (
    <Modal onCancel={noop}>
      <Modal.Header>You’re All Set!</Modal.Header>
      <Modal.Body>
        <Text>
          Thanks for subscribing to <SketchLogoBlack width="18.78px" />
          <SketchLogoText>Sketch</SketchLogoText>
        </Text>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary-untinted" onClick={handleClick}>
          Get Started
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default SubscriptionDoneModal
